/**
 * Génération d'avatars par défaut (emoji + couleur de fond) pour l'onboarding.
 *
 * On utilise un sous-ensemble « sympathique » des emojis disponibles dans
 * AvatarEditor pour éviter de tomber sur des emojis trop neutres ou tristes
 * lors du tirage aléatoire initial.
 */

const FRIENDLY_EMOJIS = [
  '😀', '😁', '😃', '😄', '😆', '😉', '😊', '😎',
  '🤩', '🥳', '🤠', '🤗', '🦊', '🐶', '🐱', '🐻',
  '🐼', '🐨', '🦁', '🐯', '🐸', '🦄', '🐝', '🦋',
  '🐙', '🦜', '🦩', '🐧', '🦒', '🦔', '🌸', '🌺',
  '🌻', '🌹', '🍀', '🌴', '🌈', '☀️', '🌙', '⭐',
  '🌟', '✨', '🔥', '💎', '🎴', '🏆', '🎯', '🎲',
];

const VIBRANT_COLORS = [
  '#e91e63', '#9c27b0', '#673ab7', '#3f51b5',
  '#2196f3', '#03a9f4', '#00bcd4', '#009688',
  '#4caf50', '#8bc34a', '#ff9800', '#ff5722',
  '#f44336', '#1a237e', '#bf360c', '#37474f',
];

export interface DefaultAvatarChoice {
  emoji: string;
  bgColor: string;
}

function pickRandom<T>(arr: readonly T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

/**
 * Tire un avatar par défaut au hasard (emoji + couleur).
 * @param exclude Évite éventuellement de retomber sur la même combinaison.
 */
export function pickRandomDefaultAvatar(
  exclude?: DefaultAvatarChoice | null,
): DefaultAvatarChoice {
  let attempts = 0;
  let choice: DefaultAvatarChoice;
  do {
    choice = {
      emoji: pickRandom(FRIENDLY_EMOJIS),
      bgColor: pickRandom(VIBRANT_COLORS),
    };
    attempts += 1;
  } while (
    exclude &&
    attempts < 8 &&
    choice.emoji === exclude.emoji &&
    choice.bgColor === exclude.bgColor
  );
  return choice;
}
